export function emailDecryption(email: string) {
    const firstName = email.split(".")[0];
    const lastName = email.split(".")[1].split("@")[0];

    const result =
        firstName.replace(firstName[0], firstName[0].toUpperCase()) +
        " " +
        lastName.replace(lastName[0], lastName[0].toUpperCase());
    return result;
}
